import { Box, TextField } from '@mui/material';
import { LabeledValue } from '~/components/Fields/LabeledValue';
import { Image3D } from '~/domain/patient/image3d';
import { ImageSeriesEdits } from '~/hooks/export/useExportEditing';

type ImageExportDetailsProps = {
    image: Image3D;
    edits?: ImageSeriesEdits;
    onSeriesDescriptionChange: (description: string) => void;
    onSeriesNumberChange: (seriesNumber: number) => void;
};

export default function ImageExportDetails({
    image,
    edits,
    onSeriesDescriptionChange,
    onSeriesNumberChange,
}: ImageExportDetailsProps) {
    const isEditable = image.isNew;
    const seriesDescription =
        edits?.seriesDescription ?? image.seriesMetadata.seriesDescription;
    const seriesNumber =
        edits?.seriesNumber ?? image.seriesMetadata.seriesNumber;

    return (
        <Box
            py={1}
            display="grid"
            gridTemplateColumns="minmax(0,2fr) minmax(0,1fr) minmax(0,1fr)"
            gap={1}
        >
            {isEditable ? (
                <TextField
                    label="Series Description"
                    value={seriesDescription}
                    onChange={(e) => onSeriesDescriptionChange(e.target.value)}
                    size="small"
                    variant="outlined"
                    inputProps={{ maxLength: 64 }}
                />
            ) : (
                <LabeledValue
                    label="Series Description"
                    value={seriesDescription}
                    sensitive
                />
            )}
            {isEditable ? (
                <TextField
                    label="Series Number"
                    value={seriesNumber}
                    onChange={(e) => {
                        const parsed = parseInt(e.target.value, 10);
                        if (!isNaN(parsed)) {
                            onSeriesNumberChange(parsed);
                        }
                    }}
                    size="small"
                    variant="outlined"
                    type="number"
                    inputProps={{ min: 0 }}
                />
            ) : (
                <LabeledValue label="Series Number" value={seriesNumber} />
            )}
            <LabeledValue label="Slices" value={image.length} />
            <LabeledValue
                label="Generation Model"
                value={image.generationModel?.label}
            />
            {image.firstSlice.manufacturerModelName && (
                <LabeledValue
                    label="Manufacturer Model Name"
                    value={image.firstSlice.manufacturerModelName}
                />
            )}
        </Box>
    );
}
